import React, { FC, useMemo } from 'react';
import { StatusDetailsProps } from './types';
import { PipelineDataGridInner } from '../PipelineDataGridInner';
import { CustomColumns, CustomTable } from '@/ui/components';
import { FormattedStatusData } from '../../types';

export const PipelineDataGrid: FC<StatusDetailsProps> = ({
  statusDetailData,
}) => {
  const columns: CustomColumns<FormattedStatusData> = useMemo(
    () => [
      {
        dataIndex: 'statusCode',
        title: 'Status Code',
        minWidth: 170,
        width: 180,
        sortable: true,
        defaultSortOrder: 'ascend',
      },
      {
        dataIndex: 'statusDesc',
        title: 'Status Description',
        minWidth: 110,
        width: 180,
      },
      {
        dataIndex: 'quantity',
        title: 'Vehicle Count',
        minWidth: 180,
      },
    ],
    [],
  );

  return (
    <CustomTable
      dataSource={statusDetailData || []}
      columns={columns}
      rowKey="statusCode"
      expandable={{
        expandedRowRender: (data) => (
          <PipelineDataGridInner statusDetailData={data.items} />
        ),
      }}
      exportOptions={{ fileName: 'Pipeline' }}
    />
  );
};
